/**
 * The scope every asset list shares, independent of site, building, floor or product.
 */

import { Filter, is } from "@the-real-insight/tri-model";

import { activeAssetsFilter } from "../utilities/activeAssets";

export interface AssetListScope {
  /**
   * Only devices without a floor and without a space — the ones no floor plan can show, because
   * they were registered in the app without one (#720/#785).
   */
  unassignedOnly?: boolean;
  /**
   * Keep devices that were decommissioned in the app. By default they are left out: they belong
   * to the archive (#780), not to any list of what is in service.
   */
  includeDecommissioned?: boolean;
}

export const assetListScopeFilters = (scope: AssetListScope = {}): Filter[] => {
  const filters: Filter[] = [];

  if (!scope.includeDecommissioned) {
    // The one definition of "still in service" — shared with the floor, room and plan reads.
    filters.push(activeAssetsFilter());
  }

  if (scope.unassignedOnly) {
    // `{ $eq: null }` matches null or absent — the same trick the `parentId` filter relies on.
    filters.push(is("floor").equal(null as any));
    filters.push(is("space").equal(null as any));
  }

  return filters;
};
